import Delta, { Op } from 'quill-delta';
import Quill from 'quill-next';
import { flatten, get, isArray } from 'lodash-es';
import type { ILQuestionDetail } from '@/utils/forEachListeningQuestion';
import { forEachListeningQuestion, getListeningState } from '@/utils/forEachListeningQuestion';
// import { Instance } from './interface';
import './listening-article';
import type { ListeningArticle } from './listening-article';
import { ListeningEventEnum } from './event';

// import './QuillEditorProxy/SubscriptTran/subscript.tran.module';


 enum AudioPlayerEvent {
  /**
   * 播放进度 data {currentTime:number, progress: number}
   */
  onProgress = 'onProgress',
  /**
   * 加载完成
   */
  onLoaded = 'onLoaded',
}

interface IHighLight {
  sentence: number;
  index: number;
  length: number;
  label: string;
}

enum MemberType {
  /** 纯文本 */
  TEXT = 'text',
  /** 问题 */
  QUESTION = 'question',
  /** 答案 */
  ANSWER = 'answer',
}
/**
 * 听力题目类型
 */
export enum ILQuestionTypeEnum {
  /** 单选 */
  MC = 1,
  /** 多选 */
  MS = 2,
  /** 表格填空 */
  TA = 3,
  /** 简答题 */
  SA = 4,
  /** 句子填空 */
  SFI = 5,
  /** 图片填空 */
  PT = 6,
  /** 图片匹配 */
  PTM = 7,
  /** 匹配题 */
  DM = 8,
  /** 自定义多选 */
  CMS = 9,
  /** 表格匹配 */
  TADM = 10
}

export type IRange = {
  index: number;
  length: number;
};

export class ListeningArticleModuleProxy {
  private _module: ListeningArticle | null = null;
  private activeHighlight: 'sign' | 'answer' | 'location' | null = null;
  private _quillInstance: Quill | null = null;
  private articleRoot: any;

  private highLightInfo: { sign: IHighLight[]; answer: IHighLight[]; location: IHighLight[]; } = {
    'sign': [],
    'answer': [],
    'location': [],
  };

  private _handleUpdateArticleStatus(key: 'answer' | 'sign' | 'location', active: boolean) {
    const last = this.activeHighlight;
    if (active) {
      this.activeHighlight = key;
    } else {
      this.activeHighlight = null;
    }
    if (this._module) {
      if (last && this.highLightInfo[last]) {
        this.highLightInfo[last].forEach((item) => {
          this.highLightItem(item.sentence, item.index, item.length, false);
        });
      }
      if (this.activeHighlight && this.highLightInfo[this.activeHighlight]) {
        this.highLightInfo[this.activeHighlight].forEach((item) => {
          this.highLightItem(item.sentence, item.index, item.length, item.label);
        });
      }
    }
  }

  private _handleUpdateArticleStatus_Translate(active: boolean) {
    if (this._module) {
      this._module.showTranslate(active);
    }
  }

  private _handleUpdateArticleStatus_Location(data: any) {
    if (this._module) {
      if (this.activeHighlight === 'location') {
        this._handleUpdateArticleStatus('location', false);
      }
      const list = get(data, 'syn_ary');
      if (isArray(list)) {
        const data = flatten(list.map((ele) => get(ele, 'target_sen'))).map((ele) => {
          return {
            sentence: ele.lyc_index,
            index: ele.index,
            length: ele.length,
            label: ' ',
          };
        });
        this.highLightInfo.location = data;
        this._handleUpdateArticleStatus('location', true);
        if (data.length > 0) {
          this._module.scrollTo(data[0].sentence);
        }
      }

    }
  }

  public _handelClick(key: string, active: any) {
    switch (key) {
      case 'translate': {
        this._handleUpdateArticleStatus_Translate(active);
        break;
      }
      case 'sign': {
        this._handleUpdateArticleStatus_Sign(active);
        break;
      }
      case 'answer': {
        this._handleUpdateArticleStatus_Answer(active);
        break;
      }
      case 'location': {
        this._handleUpdateArticleStatus_Location(active);
        break;
      }
      default: break;
    }
  }

  private _handleUpdateArticleStatus_Answer(active: boolean) {
    this._handleUpdateArticleStatus('answer', active);
  }

  private _handleUpdateArticleStatus_Sign(active: boolean) {
    this._handleUpdateArticleStatus('sign', active);
  }

  private _handleUpdateProgreaa(p: { currentTime: number; progress: number; }) {
    if (this._module) {
      this._module.updateActive(p.currentTime);
    }
  }

  /**
   * 初始化原文模块
   */
  public handleInitialArticleModule(el: any) {
    this.articleRoot = el;
    const that = this as unknown as any;
    // if (!that.commonRepository.lLoading && that.commonRepository.lRecordAnswerInfo?.length && that.commonRepository.lRecordAnswerInfo.length > 0) {
    //   that.questionRepository.answered = true;
    // }
    // if (!that.commonRepository.lLoading) 
    that.handleInitialArticleEditor();
    that.handleListenAudioPlayerProgress();

    // that.subscribeEvent(ListeningEventEnum.ARTICLE_ACTION_ANSWER, this._handleUpdateArticleStatus_Answer.bind(this), 'Listening');
    // that.subscribeEvent(ListeningEventEnum.ARTICLE_ACTION_SIGN, this._handleUpdateArticleStatus_Sign.bind(this), 'Listening');
    // that.subscribeEvent(ListeningEventEnum.ARTICLE_ACTION_TRANSLATE, this._handleUpdateArticleStatus_Translate.bind(this), 'Listening');
    // that.subscribeEvent(ListeningEventEnum.ARTICLE_ACTION_LOCATION, this._handleUpdateArticleStatus_Location.bind(this), 'Listening');
  }

  public handleListenAudioPlayerProgress() {
    const that = this as unknown as any;
    // TODO: 更新进度监听
    // that.audioPlayer.subscribeEvent(AudioPlayerEvent.onProgress, this._handleUpdateProgreaa.bind(this));

  }

  /**
   * 存储笔记
   */
  public handleSaveNote() {
    // const that = this as unknown as Instance;
    // that.publishEvent(ListeningEventEnum.SYNC_ANSWERS);
  }

  /**
   * 点击笔记
   */
  public handleClickToolsBarNoteBlot(data: any) {
    const that = this as unknown as any;
    const blot = data.blot;
    // const notes = ToolsBarModulePatch.findNotesByNoteId(blot.blotDetail.id);

    // const payload = {
    //   show: true,
    //   version: 'v2',
    //   notes: notes,
    //   blot: blot
    // };

    // that.publishEvent(ListeningEventEnum.TOOLS_BAR_NOTE_BOX_CTRL, payload);
  }

  /**
   * 创建富文本实例
   * @param item 
   */
  public createQuestionInstacneByANY(item: any, options?: any) {
    const that = this as unknown as any;
    const $options = {
      theme: 'snow',
      modules: item.group_id ? {
        toolbar: null,
      } : {
        toolbar: null,
        listeningArticle: true,
      }
    };

    if (options) {
      options.modules['mark'] = {
        panel: 'question-mark-panel',
        container: 'l-question-root',
        scroll: true
      };
      options.modules['tools'] = {
        quillInstanceId: item.key,
        shouldShowToolbarOnEventListening: false,
      };
    }

    const instance = new Quill(`#${item.key}`, options ? options : $options);
    if (instance) {
      instance.root.setAttribute('spellcheck', 'false');
      instance.root.setAttribute('contenteditable', 'false');

      // 顶部题干的标题区域没有选区操作
      if (item.member_type === MemberType.TEXT) {
        instance.root.style.userSelect = 'none';
      }

      // 保存实例
      if (!that.questionInstanceRepository) that.questionInstanceRepository = new Map();
      that.questionInstanceRepository.set(item.key, instance);

      // 将两种拖拽题的选区操作移动到别的地方
      // 由 pointerup 触发
      // if (item.type !== ILQuestionTypeEnum.DM && item.type !== ILQuestionTypeEnum.TADM) {
      //   instance.on('selection-change', (range: IRange, oldRange: IRange, source: string) => {
      //     if (range && range.length > 0) {
      //       that.onEditorSelectionChange({
      //         range,
      //         instance,
      //         question: item,
      //         source,
      //         oldRange
      //       });
      //     }
      //   });
      // }

      // 保存笔记
      instance.on('save-note', that.handleSaveNote.bind(that));
      // 点击笔记
      instance.on('on-click-tools-bar-note-blot', that.handleClickToolsBarNoteBlot.bind(this));
    }
  }


  public handleInitialArticleEditor() {
    const that = this as unknown as any;
    const domNode = that.articleRoot;
    const key = domNode?.getAttribute('id');
    that.createQuestionInstacneByANY({ key });
    that.createArticleEditorContent();

    setTimeout(() => {
      this.initHighlightInfo();
    }, 1);
    // requestIdleCallback(() => {
    //   this.initHighlightInfo();
    // });
  }

  getPaperInfo() {
    return getListeningState().pageData.question;
  }

  public createArticleEditorContent() {
    const that = this as unknown as any;
    const domNode = that.articleRoot;
    const id = domNode?.getAttribute('id');
    const instance = that.questionInstanceRepository?.get(id || '');
    if (instance) {
      this._quillInstance = instance;
      const lPaperInfo:any = this.getPaperInfo();

      const contents = lPaperInfo?.content || [];

      const ops: Op[] = [];

      contents.forEach((item: any, index: number) => {
        if (item.en_text && item.cn_text) {
          ops.push({
            insert: `${item.en_text}\n`,
            attributes: {
              'listening-article-en': {
                startTime: item.start_time,
                endTime: item.end_time,
                order: index,
              },
            },
          });
          ops.push({
            insert: `${item.cn_text}\n`,
            attributes: {
              'listening-article-cn': true,
            },
          });
        }
      });

      const delta = new Delta(ops);

      instance.setContents(delta as any);
      (window as any).textual = instance;
      const m = instance.getModule('listeningArticle');
      if (m) {
        that._module = m as ListeningArticle;
        that._module.updateActive(0);
      }
    }
  }

  public initHighlightInfo() {
    const that = this as unknown as any;
    const lPaperInfo = this.getPaperInfo();
    const contents = lPaperInfo?.content || [];
    const sign: IHighLight[] = [];
    const answer: IHighLight[] = [];
    const answerMap: Map<number, Set<number>> = new Map();

    forEachListeningQuestion((question: ILQuestionDetail) => {
      // 
      question.locating_words.forEach((ele) => {
        if (ele.syn_ary) {
          ele.syn_ary.forEach((sens) => {
            sens.target_sen.forEach((sent) => {
              sign.push({
                sentence: sent.lyc_index,
                index: sent.index,
                length: sent.length,
                label: `(Q${question.number})`,
              });
            });
          });
        }
      });

      // lyc_index 是一个前闭后开区间
      if (question.answer_sentences && question.answer_sentences.lyc_index.length === 2) {
        for (let i = question.answer_sentences.lyc_index[0]; i < question.answer_sentences.lyc_index[1]; i++) {
          if (answerMap.has(i)) {
            answerMap.get(i)?.add(question.number);
          } else {
            answerMap.set(i, new Set([question.number]));
          }
        }
      }
    });

    answerMap.forEach((questionList, lyc_index) => {
      const s = contents.find((con: any) => con.order === lyc_index);
      if (s) {
        answer.push({
          sentence: s.order,
          index: 0,
          length: s.en_text.length,
          label: `(Q${Array.from(questionList).join(' Q')})`,
        });
      }
    });

    this.highLightInfo.sign = sign;
    this.highLightInfo.answer = answer;

  }

  private highLightItem(sencence: number, index: number, length: number, label: string | boolean) {
    if (this._module && this._quillInstance) {
      const blot = this._module?.findEn(sencence);
      if (blot) {
        const offset = blot.offset(this._quillInstance.root);
        if (typeof offset === 'number') {
          this._quillInstance.formatText({
            index: offset + index,
            length,
          }, 'listening-article-highlight', label);
        }
      }

    }

  }
}

// instance.formatText(200, 100, 'listening-article-highlight', 11 ) // 11 是题号
